import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Key, CheckCircle, X, HardHat } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const InvitationAcceptPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [invitation, setInvitation] = useState(null);
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/access/invitations/verify/${token}`);
        setInvitation(res.data);
      } catch (e) {
        setError(e.response?.data?.detail || 'Invitation invalide');
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Mot de passe de 8 caracteres minimum');
    if (password !== confirm) return toast.error('Les mots de passe ne correspondent pas');
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/access/invitations/accept/${token}`, { password });
      setDone(true);
      toast.success('Compte cree ! Vous pouvez maintenant vous connecter.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading-container"><div className="spinner" /></div>;

  const cardStyle = { backgroundColor: 'white', borderRadius: '10px', padding: '36px 32px', maxWidth: '440px', width: '100%', boxShadow: '0 10px 40px rgba(0,0,0,0.12)' };
  const wrapStyle = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', backgroundColor: '#F4F5F7' };

  if (error) {
    return (
      <div style={wrapStyle}>
        <div style={cardStyle} data-testid="invitation-error">
          <div style={{ textAlign: 'center' }}>
            <X size={48} color="#C62828" weight="bold" />
            <h2 style={{ margin: '16px 0 8px' }}>Invitation invalide</h2>
            <p style={{ color: '#5E5F66', marginBottom: '20px' }}>{error}</p>
            <button className="btn btn-primary" onClick={() => navigate('/login')}>Aller a la connexion</button>
          </div>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div style={wrapStyle}>
        <div style={cardStyle} data-testid="invitation-done">
          <div style={{ textAlign: 'center' }}>
            <CheckCircle size={48} color="#2E7D32" weight="bold" />
            <h2 style={{ margin: '16px 0 8px' }}>Compte cree !</h2>
            <p style={{ color: '#5E5F66' }}>Redirection vers la connexion...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={wrapStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <HardHat size={40} color="#002FA7" weight="bold" />
          <h1 style={{ margin: '12px 0 4px', fontSize: '1.5rem' }}>BATI-BOYS</h1>
          <p style={{ color: '#5E5F66', margin: 0, fontSize: '0.9rem' }}>Invitation a rejoindre l'equipe</p>
        </div>

        <div style={{ padding: '14px', backgroundColor: '#F0F9FF', borderRadius: '6px', marginBottom: '20px', border: '1px solid #BAE6FD', fontSize: '0.9rem' }}>
          <div><strong>{invitation.name}</strong></div>
          <div style={{ color: '#075985' }}>{invitation.email}</div>
          <div style={{ fontSize: '0.8rem', color: '#075985', marginTop: '4px' }}>Role : {invitation.role === 'admin' ? 'Administrateur' : 'Salarie'}</div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Mot de passe *</label>
            <input type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="invite-password" />
            <small style={{ color: '#5E5F66', fontSize: '0.75rem' }}>8 caracteres minimum</small>
          </div>
          <div className="form-group">
            <label className="form-label">Confirmer le mot de passe *</label>
            <input type="password" className="form-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="invite-password-confirm" />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginTop: '12px' }} disabled={submitting} data-testid="invite-submit">
            <Key size={16} /> {submitting ? 'Creation...' : 'Creer mon compte'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default InvitationAcceptPage;
